import gsap from 'gsap'

import Swiper from "swiper"
import { Navigation, Autoplay, FreeMode, EffectFade, Pagination } from "swiper/modules"

import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/free-mode"
import "swiper/css/effect-fade"

export const initSwiper = () => {
	related()
	team()
}

const related = () => {

	let els = document.querySelectorAll('[data-swiper="related"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation],
			grabCursor: true,
			spaceBetween: 20,
			slidesPerView: 1.25,
			centeredSlides: true,
			loop: true,
			speed: 300,
			breakpoints: {
				650: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				}
			},
			navigation: {
				prevEl: el.querySelector('.related__navigation--prev'),
				nextEl: el.querySelector('.related__navigation--next'),
			},
		})
	})
}

const team = () => {

	let els = document.querySelectorAll('[data-swiper="team"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation],
			grabCursor: true,
			spaceBetween: 20,
			slidesPerView: 1.25,
			loop: false,
			speed: 300,
			breakpoints: {
				650: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 4,
					spaceBetween: 20,
				},
			},
			navigation: {
				prevEl: el.querySelector('.team__navigation--prev'),
				nextEl: el.querySelector('.team__navigation--next'),
			},
		})
	})
}

export default () => { }